import { Component, OnInit, OnDestroy } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { UploadService } from '../../services/core.upload.service';
import { UserService } from '../../services/core.user.service';
import { UiService } from '../../services/core.ui.service';
import { GfTranslateService } from '../../services/core.translate.service';
import { NotificationService } from '../../services/core.notification.service';
import { SiteConfigService } from '../../services/core.site-config.service';

import * as _ from 'lodash-es';

@Component({
    selector: 'gf-feedback-button',
    template: require('./feedback.html')
})
export class FeedbackComponent implements OnInit, OnDestroy {

    private draggingOver = false;
    private maxAttachmentSize = '5Mb';
    private modelTemplate: any = { //vanilla template, used to reset this.post
        summary: '',
        description: '',
        browser: <any>{},
        requestedContact: false,
        url: '',
        attachment: null
    };
    protected post = _.clone(this.modelTemplate);
    protected trackeritem: any = false;
    protected feedbackTracker = 0;
    protected hasUser = false;
    private user: any = null;
    protected submitting = false;
    protected ticketUrl: string;
    protected browseUrl: string = '/project/gforge5/tracker/11116/browse?query=41577';

    constructor(
        private window: Window, 
        private httpClient: HttpClient,
        private uploadService: UploadService,
        private userService: UserService,
        private uiService: UiService,
        private gfTranslateService: GfTranslateService,
        private notificationService: NotificationService,
        private siteConfigService: SiteConfigService,        
    ) { }

    ngOnDestroy(): void {
        this.notificationService.unsubscribe('feedback');
    }
    
    ngOnInit() {

        //verify at the start if feedbackTracker is defined and user in session

        // BUG - this is actually hard-coded in the "go to my support" link in this modal
        // because we also need the project unixname - so they're both hard-coded in the ui-sref
        const siteConfig = this.siteConfigService.getSiteConfig();
        this.feedbackTracker = _.get(siteConfig, 'feedbackTracker', false);
        this.hasUser = this.userService.session.hasUser();
        this.user = this.userService.session.getUser();

        this.notificationService.subscribe('feedback', 'DRAGOVER_START_EVENT', () => {
            if (!this.draggingOver) {
                this.draggingOver = true;
            }
        });

        this.notificationService.subscribe('feedback', 'DRAGOVER_END_EVENT', () => {
            this.draggingOver = false;
        });
    };

    dismissModal() {
        ($('#feedbackModal') as any).modal('hide');
    }

    resetData () {
        this.post = _.clone(this.modelTemplate);

        this.post.url = this.window.location.href;
        this.post.browser = {
            appCodeName: _.get(this.window, 'navigator.appCodeName', ''),
            appName: _.get(this.window, 'navigator.appName', ''),
            appVersion: _.get(this.window, 'navigator.appVersion', ''),
            platform: _.get(this.window, 'navigator.platform', ''),
            userAgent: _.get(this.window, 'navigator.userAgent', '')
        };

        this.trackeritem = false;
    };

    // Returns a promise. Process form submit
    postFeedback () {
        var postData = {
            tracker: this.feedbackTracker,
            summary: this.post.summary,
            details: this.post.description,
            extraFields: {
                url: this.post.url,
                browser: this.post.browser.appCodeName
                    + ' ' + this.post.browser.appName
                    + ' ' + this.post.browser.appVersion,
                platform: this.post.browser.platform,
                useragent: this.post.browser.userAgent
            }
        };
        this.submitting = true;
        var promise = this.httpClient.post('/api/trackeritem', postData)
        .toPromise()
        .then((data) => {
            this.trackeritem = data;

            this.ticketUrl = `/trackeritem/${ this.trackeritem.id }`;

            if (this.post.attachment) {
                this.uploadAttachment(_.get(data, 'id', 0));
            } else {
                this.resetData();
            }
            this.uiService.message.showSuccess(
                this.gfTranslateService.translate('Your feedback was posted successfully'),
                'Feedback'
            );

            // Close the modal after successful submission
            this.dismissModal();
        }, (data) => {
            this.uiService.message.showError(
                this.gfTranslateService.translate('Error posting feedback, please try again'),
                'Feedback'
            );
            console.log(data);
        }).finally(() => { this.submitting = false; });
        return promise;
    };

    fileSelected = ($event) => {
        this.addFile($event?.target?.files);
    };

    //when user selects a file store it locally, it will be uploaded
    // after submit creates a new valid tracker item
    addFile = ($files) => {
        if (($files !== undefined) && $files.length == 1) {
            this.post.attachment = $files[0];
        } else {
            this.post.attachment = null;
        }
    };

    /**
     * Private. Callback method for setting a chunked uploaded
     * file as an attachment for the given ti id (refId)
     * @param {string} section 
     * @param {id} refId 
     * @param {object} file 
     * @param {string} hash 
     */
    setAttachment = (section, refId, file, hash) => {
        var params = {
            fileName: file.name,
            fileType: (!_.isEmpty(file.type)) ? file.type : 'application/octet-stream'
        };

        const url = `/api/trackeritem/${refId}/attachment/${hash}`
        return this.httpClient.post(url, params)
            .toPromise()
            .then(
                (response) => {
                    console.log('Success', response);
                },
                (response) => {
                    this.uiService.message.showWarning(
                        this.gfTranslateService.translate(
                            'Your feedback was posted successfully but there was a problem uploading your attachment.'
                        ),
                        'Feedback'
                    );
                    console.log(response);
                }
            );
    };

    //called after the new tracker item was created, handles file upload
    uploadAttachment(feedbackId) {
        var options = {
            successCallback: this.setAttachment
        };

        this.uploadService.uploadFiles('trackeritem', feedbackId, [this.post.attachment], options);
    }
}
